import React, {Component} from "react";
import PropTypes from "prop-types";
import classNames from "classnames"
import columnStyles from "./column.module.pcss";

const Column = ({children, width, customColumnClass}) => {

  const columnInlineStyles = {width: width};

  return (
    <div style={columnInlineStyles} className={classNames(columnStyles.column, customColumnClass)}>
      {children}
    </div>
  )
};

Column.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  width: PropTypes.string,
  customColumnClass: PropTypes.string
};

export default Column;


// WEBPACK FOOTER //
// ./src/components/column/column.js